exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".size-modal-content[data-v-1738b80e]{padding:10px;font-style:13px;background-color:#fff;padding-right:50px}.v--modal-overlay[data-modal=size-modal][data-v-1738b80e]{background:rgba(0,0,0,.5);z-index:555555!important}.demo-modal-class[data-v-1738b80e]{border-radius:5px;background:#f7f7f7;box-shadow:5px 5px 30px 0 rgba(46,61,73,.6)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1738b80e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/footer/SecondRow.vue
// module id = 320
// module chunks = 0